(() => {
  let busy = false;
  const page = () => document.querySelector('[data-cart-page]');

  function setBusy(value) {
    busy = value;
    const container = page();
    container.setAttribute('aria-busy', String(value));
    container.querySelectorAll('button, .cart-qty').forEach(control => {
      control.disabled = value;
    });
    const accelerated = container.querySelector('.add-buttons');
    if (accelerated) accelerated.inert = value;
  }

  async function changeQuantity(input, quantity) {
    if (busy) return;
    const container = page();
    const previous = Number(input.dataset.quantity);
    const status = container.querySelector('#cart-update-status');
    if (!Number.isSafeInteger(quantity) || quantity < 0) {
      input.value = previous;
      status.textContent = 'Enter a whole number of zero or more.';
      return;
    }
    if (quantity === previous) return;
    const note = container.querySelector('[name="note"]')?.value;
    const activeRow = input.closest('.cart-row');
    const rowIndex = [...container.querySelectorAll('.cart-row')].indexOf(activeRow);
    const editing = activeRow.classList.contains('cart-row-edit-active');
    setBusy(true);
    status.textContent = 'Updating cart…';
    let changed = false;
    try {
      const response = await fetch(container.dataset.cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: input.dataset.key, quantity })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || 'Unable to update this item.');
      changed = true;
      const htmlResponse = await fetch(container.dataset.cartUrl, { cache: 'no-store' });
      if (!htmlResponse.ok) throw new Error('Unable to refresh cart.');
      const documentFragment = new DOMParser().parseFromString(await htmlResponse.text(), 'text/html');
      const updated = documentFragment.querySelector('[data-cart-page]');
      if (!updated) throw new Error('Unable to refresh cart.');
      container.replaceWith(updated);
      const noteInput = updated.querySelector('[name="note"]');
      if (noteInput && note !== undefined) noteInput.value = note;
      document.querySelectorAll('#meta .count').forEach(count => { count.textContent = cart.item_count; });
      const message = updated.querySelector('#cart-update-status');
      if (message) message.textContent = 'Cart updated.';
      setBusy(false);
      const nextRow = updated.querySelectorAll('.cart-row')[rowIndex];
      if (nextRow && editing) nextRow.classList.add('cart-row-edit-active');
      nextRow?.querySelector('.cart-qty')?.focus({ preventScroll: true });
    } catch (error) {
      input.value = previous;
      if (changed || error instanceof TypeError) {
        location.reload();
        return;
      }
      status.textContent = error.message;
      setBusy(false);
    }
  }

  document.addEventListener('click', event => {
    const control = event.target.closest('[data-cart-page] .cart-qty-add, [data-cart-page] .cart-qty-subtract, [data-cart-page] .remove, [data-cart-page] .cart-mobile-edit');
    if (!control) return;
    event.preventDefault();
    if (busy) return;
    const row = control.closest('.cart-row');
    if (control.matches('.cart-mobile-edit')) {
      row.classList.toggle('cart-row-edit-active');
      return;
    }
    const input = row.querySelector('.cart-qty');
    const quantity = control.matches('.remove') ? 0 : Math.max(0, Number(input.dataset.quantity) + (control.matches('.cart-qty-add') ? 1 : -1));
    changeQuantity(input, quantity);
  });

  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-page] .cart-qty')) {
      changeQuantity(event.target, event.target.value.trim() === '' ? NaN : Number(event.target.value));
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-cart-page] .cart-qty')) {
      event.preventDefault();
      event.target.blur();
    }
  });

  document.addEventListener('submit', event => {
    if (busy && event.target.id === 'cart-form') event.preventDefault();
  }, true);

  window.addEventListener('pageshow', event => {
    if (event.persisted) location.reload();
  });
})();
